export default "__VITE_ASSET__LjXBb0el__"